import { useReactToPrint } from "react-to-print";

export function useImprimirFacturaTermica(facturaRef: React.RefObject<HTMLDivElement | null>) {
  return useReactToPrint({
    contentRef: facturaRef,
    documentTitle: "Recibo",
    pageStyle: `
      @page { size: 80mm auto; margin: 0; }
      @media print { body { margin: 0; } }
    `,
  });
}
